import React, { useEffect } from 'react';
import checkoutBannerImg from '../../utils/assets/shared/bgImg.png';
import onbgImg from '../../utils/assets/checkout/onbg1.png';
import WelcomeSection from '../../shared/components/WelcomeSection/WelcomeSection';
import NavegationInfo from '../../shared/components/NavegationInfo/NavegationInfo';
import PaymentInfo from '../components/PaymentInfo/PaymentInfo';
const Checkout = () => {

    const bannerSectionInfo =
    {
       cardTitle: "We are so excited that you are joining us here today!   ",
       cardBodyText: ``,
       cardButtonText: "",                    
       lengendBackground: checkoutBannerImg,
       cardImg : onbgImg
    }
    useEffect(()=>{
        window.scroll(0,0)
    },[])

    return (
        <React.Fragment>
           <WelcomeSection props={bannerSectionInfo}/>
           <NavegationInfo page="Checkout"/>
           <PaymentInfo/>
        </React.Fragment>
    );
};

export default Checkout;
           